import { z } from 'zod';

import { type RouteExportParams } from '~/types/router.type';

export const validateSearch = z.object({
  userGroupId: z.uuid().optional(),
});

export const routeParams: RouteExportParams = {
  permissions: ['user_group.'],
};
